import {
  preFormatForm,
  taskConstraints,
  trimInputValues,
  validateForm,
  statusStylesObject,
  IndicatorSeparator,
  DropdownIndicator,
  getTranslatedText,
  BackgroundIcon,
  ALL_MODULES,
  Loader,
  TEXT_LENGTH,
  DeleteModal,
  Editor
} from '@nile/components';
import {
  AccountClient,
  GET_ALL_TECHS_NEW,
  GET_ALL_TECH_GROUP,
  GET_ALL_WORK_STATUSES,
  TicketClient
} from '@nile/graphql';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { SVGIcon } from '@superops/super-icons';
import {
  Button,
  TextField as NumberInput,
  Page,
  TextStyle,
  Avatar,
  ButtonGroup,
  TextField,
  Link,
  Dropdown as Select,
  DateTimePicker
} from '@superops/ui-design-system';
import dompurify from 'dompurify';
import dayjs from 'dayjs';
import React, { Component } from 'react';
import styled from 'styled-components';
import { cloneDeep } from 'lodash';
import envConfig from '@nile/home/src/Config/env';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import { FormattedMessage, injectIntl } from 'react-intl';
import { reactSelectErrorStyles, reactSelectInlineError } from '../Utils/style';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const ModalContent = styled.div`
  width: 1000px;
  .wrapper {
    min-height: calc(100vh - 500px);
    height: 100%;
    max-height: calc(100vh - 270px);
  }
`;

const EditContainer = styled.div`
  width: 70%;
  .task-heading {
    input {
      font-size: 24px !important;
      font-weight: 600 !important;
    }
  }

  .editor-holder {
    height: calc(100% - 100px);
  }
`;

const DetailsContainer = styled.div`
  width: 30%;
  padding-left: 20px;
  margin-left: 30px;
  border-left: 1px solid #ececec;
  .status-select-wrapper {
    margin-left: -10px;
    .Superops-Dropdown__control {
      border-bottom: none !important;
    }
  }
  .w-130 {
    width: 130px;
  }
`;

const EditorHolder = styled.div`
  #quill-rt-editor {
    height: 100%;
    .quill {
      height: 100%;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
          padding-left: 10px !important;
          padding-right: 10px !important;
          &.ql-blank::before {
            left: 10px;
          }
        }
      }
    }
    .ql-toolbar {
      border: none;
      padding: 8px 0 !important;
    }
  }
`;

const RadioWrapper = styled.div`
 border: 0.2rem solid ${(props) =>
   props.checked ? 'rgba(1, 31, 255, 1)' : 'rgba(158, 158, 158, 1)'};
 border-radius: 50%;
 cursor: pointer;
 min-height: 18px;
 min-width: 18px;
 .inside {
 background-color: rgba(1, 31, 255, 1);
 border-radius: 50%;
 display: ${(props) => (props.checked ? 'block' : 'none')}
 min-height: 10px;
 min-width: 10px;
 }
`;

const CustomRadioButton = ({ checked, onClick }) => {
  return (
    <RadioWrapper
      className="fx actr jctr"
      checked={checked}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      <div className="inside" />
    </RadioWrapper>
  );
};

class TaskForm extends Component {
  static contextType = TabContext;
  constructor(props) {
    super(props);
    this.state = {
      task: {
        name: props.type ? props.task.name : props?.data?.title || '',
        description: props?.data?.description || '',
        status: props?.data?.status || 'Planned',
        estimatedTime: props?.data?.estimatedTime || 0,
        scheduledStartDate: !props.isTemplate
          ? props?.data?.scheduledStartDate
          : props?.data?.scheduledStartDate || {
              unit: 'CUSTOM',
              value: 'TODAY'
            },
        dueDate: props?.data?.dueDate,
        technician: props?.data?.technician,
        techGroup: props?.data?.techGroup,
        taskOrder: props.data?.taskOrder
      },
      template: {
        name: '',
        content: dompurifier(props?.data?.description) || '',
        placeholdersUsed: '',
        inlineImages: []
      },
      selected: 0,
      hrValue: 0,
      minValue: 0,
      allTechGroups: null,
      allTechnicians: null,
      allAvailableTechs: null,
      allWorkStatus: null,
      errors: null,
      submitActionLoading: false,
      loading: false
    };
  }

  getAllTechnicians = () => {
    this.setState({ loading: true });
    AccountClient.query({
      query: GET_ALL_TECHS_NEW,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    }).then((res) => {
      if (res.data?.getTechnicianList?.userList) {
        const allTechnicians = res.data.getTechnicianList.userList.map(
          (item) => ({
            ...item,
            label: item.name,
            value: item.name
          })
        );
        this.setState({
          allAvailableTechs: allTechnicians,
          allTechnicians: allTechnicians
        });
      }
      this.setState({ loading: false });
    });
  };

  getTechnicianGroups = () => {
    this.setState({ loading: true });

    AccountClient.query({
      query: GET_ALL_TECH_GROUP,
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (res.data.getTechnicianGroups) {
        if (this.props?.data?.techGroup) {
          const currentTechGroup = res.data.getTechnicianGroups.filter(
            (grp) => grp.groupId === this.props.data.techGroup.groupId
          );
          const allUsers = currentTechGroup?.[0]?.userList;
          this.setState({
            allTechGroups: res.data.getTechnicianGroups.map((item) => ({
              ...item,
              id: item.name,
              value: item.name,
              label: item.name
            })),
            allTechnicians: allUsers?.map((item) => ({
              ...item,
              id: item.name,
              value: item.name,
              label: item.name
            }))
          });
        } else {
          this.setState({
            allTechGroups: res.data.getTechnicianGroups.map((item) => ({
              ...item,
              id: item.name,
              value: item.name,
              label: item.name
            }))
          });
        }
      }
      this.setState({ loading: false });
    });
  };

  getWorkStatuses = () => {
    this.setState({ loading: true });
    TicketClient.query({
      query: GET_ALL_WORK_STATUSES,
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (res.data?.getWorkStatuses) {
        const allWorkStatus = res.data?.getWorkStatuses.map((el) => ({
          ...el,
          id: el?.name,
          label: el?.name,
          value: el?.name
        }));
        this.setState({
          allWorkStatus: allWorkStatus
        });
      }
      this.setState({ loading: false });
    });
  };

  componentDidMount = () => {
    if (this.props?.data?.estimatedTime) {
      const actualTime = this.props.data.estimatedTime;
      const hrs = `${Math.floor(actualTime / 60)}`;
      const mins = `${actualTime % 60}`;
      this.setState({ hrValue: hrs, minValue: mins });
    }

    this.getAllTechnicians();
    this.getTechnicianGroups();
    this.getWorkStatuses();
  };

  handleTimeCalculation = (val, type) => {
    const newVal = val || '0';
    this.setState({ [type]: val });
    const { hrValue, minValue } = this.state;
    const calculatedMins =
      type === 'hrValue'
        ? parseInt(newVal * 60, 10) + parseInt(minValue, 10)
        : parseInt(hrValue * 60, 10) + parseInt(newVal, 10);
    const { task } = this.state;
    const updatedTask = { ...task };
    updatedTask.estimatedTime = calculatedMins;
    this.setState({ task: updatedTask });
  };

  selectDateHandler = (val, type) => {
    const date = new Date(val);
    const formatted = val ? dayjs(date).format('YYYY-MM-DDTHH:mm:ss') : null;
    const { task } = this.state;
    const updatedTask = { ...task };
    updatedTask[type] = formatted;
    this.setState({ task: updatedTask });
  };

  handleTemplateDateHandler = (val, type) => {
    const { task } = this.state;
    const updatedTask = { ...task };
    updatedTask[type] = val;
    this.setState({ task: updatedTask });
  };

  handleTabChange = (idx) => {
    this.setState({ selected: idx });
  };

  updateStatus = (statusObj) => {
    const { task } = this.state;
    const updatedTask = { ...task };
    updatedTask.status = statusObj.name;
    this.setState({ task: updatedTask });
  };

  handleChange(field) {
    return (value) => {
      const { task } = this.state;
      task[field] = value;
      if (field === 'name') {
        this.setState((prevState) => ({
          task: task,
          errors: { ...prevState.errors, name: null }
        }));
      } else {
        this.setState({ task: task });
      }
    };
  }

  constructSelectObj = (obj) => {
    if (obj) {
      const { label, description, userList, clientList, value, ...rest } = obj;
      return rest;
    }
    return null;
  };

  createTask() {
    this.setState({ submitActionLoading: true });
    const dummyForm = { ...this.state.task };
    dummyForm.description = dompurifier(this.state.template.content);
    const validationResult = validateForm(
      preFormatForm(dummyForm),
      taskConstraints
    );
    if (validationResult) {
      this.setState({ errors: validationResult, submitActionLoading: false });
      return;
    }
    this.setState({ errors: {} });
    let trimmedForm = { ...this.state.task };
    trimmedForm.description = dompurifier(this.state.template.content);
    trimmedForm = trimInputValues(trimmedForm);
    trimmedForm.technician = this.constructSelectObj(trimmedForm.technician);
    trimmedForm.techGroup = this.constructSelectObj(trimmedForm.techGroup);
    trimmedForm.inlineImages = this.state.template?.inlineImages || [];
    trimmedForm.scheduledStartDate =
      (this.props.isTemplate &&
        trimmedForm.scheduledStartDate?.value?.toString()) ||
      !this.props.isTemplate
        ? trimmedForm.scheduledStartDate || null
        : null;
    trimmedForm.dueDate =
      (this.props.isTemplate && trimmedForm.dueDate?.value?.toString()) ||
      !this.props.isTemplate
        ? trimmedForm.dueDate || null
        : null;
    this.props.addOrUpdateTechGroup(this.props.type, trimmedForm);
  }

  updateTemplate = (obj) => {
    const updatedTemplate = cloneDeep(this.state.template);
    this.setState({ template: { ...updatedTemplate, ...obj } });
  };

  handleTechGroupSelect = (value) => {
    if (value) {
      return this.state.allTechGroups?.find(
        (group) => group.groupId === value.groupId
      );
    }
    return null;
  };

  handleTechicianSelect = (value) => {
    if (value) {
      return this.state.allTechnicians?.find(
        (user) => user.userId === value.userId
      );
    }
    return null;
  };

  getStatusObj = (name) => {
    if (this.state.allWorkStatus) {
      return this.state.allWorkStatus?.find(
        (status) => status.state === name || status.name === name
      );
    }
  };

  updateSelectFields(key, field) {
    const { task } = this.state;
    task[key] = field;
    if (key === 'techGroup') {
      if (field) {
        const allUsers = field.userList.map((item) => ({
          ...item,
          label: item.name,
          value: item.name
        }));
        if (!allUsers.find((user) => user.userId === task.technician?.userId)) {
          task.technician = null; //null case to reset technician
        }
        this.setState({ task: task, allTechnicians: allUsers });
      } else {
        task.technician = null; //null case to reset technician
        this.setState({
          task: task,
          allTechnicians: this.state.allAvailableTechs
        });
      }
    } else if (key === 'technician') {
      this.setState((prevState) => ({
        task: task,
        errors: { ...prevState.errors, technician: null }
      }));
    } else {
      this.setState({ task: task });
    }
  }

  selectCustomUnit = () => {
    this.handleTemplateDateHandler(
      { unit: 'CUSTOM', value: 'TODAY' },
      'scheduledStartDate'
    );
  };

  selectDaysUnit = () => {
    this.handleTemplateDateHandler(
      { unit: 'DAY', value: '0' },
      'scheduledStartDate'
    );
  };

  stopEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const {
      task,
      errors,
      hrValue,
      minValue,
      submitActionLoading,
      template
    } = this.state;
    const {
      intl,
      toggleSheetActive,
      meta,
      data,
      module,
      hideSections = [],
      details,
      showParent,
      onDeleteHandler,
      ticketViewPermission,
      showDelete,
      disableEdit,
      isTemplate
    } = this.props;

    return (
      <>
        <ModalContent>
          <div>
            <Page
              title={meta.title}
              primaryAction={
                <ButtonGroup>
                  <Button plainSecondary onClick={toggleSheetActive}>
                    <FormattedMessage id="common.cancel" />
                  </Button>
                  {showDelete && (
                    <DeleteModal
                      description={getTranslatedText(
                        intl,
                        'ticket.details.task.delete.confirm'
                      )}
                      handleDeleteConfirmation={onDeleteHandler}
                      title={getTranslatedText(
                        intl,
                        'ticket.details.task.delete.text'
                      )}
                      zIndex={1500}
                    />
                  )}
                  <Button
                    primary
                    icon={<SVGIcon name="Save" color="#fff" />}
                    onClick={this.createTask.bind(this)}
                    loading={submitActionLoading}
                    disabled={disableEdit}
                  >
                    <FormattedMessage id="common.save" />
                  </Button>
                </ButtonGroup>
              }
              variant="primary"
            >
              <div className="full-width flex fx-sb wrapper">
                {this.state.loading ? (
                  <div className="full-width">
                    <Loader />
                  </div>
                ) : (
                  <>
                    <EditContainer>
                      <div className="task-heading">
                        <TextField
                          placeholder={getTranslatedText(
                            intl,
                            'admin.runbooks.tasks.copy.name.pl'
                          )}
                          value={task.name}
                          onChange={this.handleChange('name')}
                          error={errors?.name?.[0]}
                          maxLength={TEXT_LENGTH.size_5}
                          disabled={disableEdit}
                        />
                      </div>
                      <EditorHolder className="editor-holder mt-10">
                        {/* <EmailEditor
                          template={template}
                          updateTemplate={this.updateTemplate}
                          // handleFileAttachments={this.handleFileAttachments}
                          placeholder={getTranslatedText(
                            intl,
                            'admin.runbooks.tasks.copy.pl.desc'
                          )}
                          module={module || 'TICKET'}
                          details={details || { operation: 'CREATE' }}
                          disabled={disableEdit}
                        /> */}

                        <Editor
                          focusEditor
                          template={template}
                          updateTemplate={this.updateTemplate}
                          module={module || 'TICKET'}
                          details={details || { operation: 'CREATE' }}
                          // handleFileAttachments={this.handleFileAttachments}
                          placeholder={getTranslatedText(
                            intl,
                            'admin.runbooks.tasks.copy.pl.desc'
                          )}
                          allowMultiple
                          config={{
                            htmlUntouched: true
                          }}
                          disableAttachment
                        />
                      </EditorHolder>
                    </EditContainer>

                    <DetailsContainer>
                      {!hideSections.includes('status') && (
                        <div className="mb-20 ">
                          <div className="mb5">
                            <TextStyle variation="subdued">
                              <FormattedMessage id="common.status" />
                            </TextStyle>
                          </div>
                          <div className="status-select-wrapper">
                            <Select
                              value={this.getStatusObj(task.status)}
                              styles={
                                errors?.statusId
                                  ? {
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999
                                      }),
                                      ...reactSelectErrorStyles,
                                      ...statusStylesObject
                                    }
                                  : {
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999
                                      }),
                                      ...statusStylesObject
                                    }
                              }
                              isDisabled={disableEdit}
                              name="team"
                              components={{
                                IndicatorSeparator,
                                DropdownIndicator
                              }}
                              onChange={this.updateStatus}
                              options={this.state.allWorkStatus || []}
                              isSearchable={false}
                            />
                            {errors?.statusId &&
                              reactSelectInlineError(errors.statusId[0])}
                          </div>
                        </div>
                      )}

                      {!hideSections.includes('techGroup') && (
                        <div className="mb-20 ">
                          <div className="mb5">
                            <TextStyle variation="subdued">
                              <FormattedMessage id="admin.runbooks.tasks.copy.config.techgrp" />
                            </TextStyle>
                          </div>
                          <div className="fx actr">
                            <div
                              className="fx center mr-10"
                              style={{ opacity: 0.6 }}
                            >
                              <SVGIcon name="TechnicianGroup" />
                            </div>
                            <div className="f11">
                              <Select
                                isClearable
                                value={
                                  task?.techGroup?.name
                                    ? {
                                        name: task?.techGroup?.name,
                                        value: task?.techGroup?.name,
                                        label: task?.techGroup?.name
                                      }
                                    : null
                                }
                                styles={
                                  errors?.groupId
                                    ? {
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 9999
                                        }),
                                        ...reactSelectErrorStyles
                                      }
                                    : {
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: 9999
                                        })
                                      }
                                }
                                components={{
                                  IndicatorSeparator,
                                  DropdownIndicator
                                }}
                                name="team"
                                onChange={this.updateSelectFields.bind(
                                  this,
                                  'techGroup'
                                )}
                                options={this.state.allTechGroups || []}
                                isDisabled={disableEdit}
                              />
                            </div>
                            {errors?.groupId &&
                              reactSelectInlineError(errors.groupId[0])}
                          </div>
                        </div>
                      )}

                      {!hideSections.includes('technician') && (
                        <div className="mb-20 ">
                          <div className="mb5">
                            <TextStyle variation="subdued">
                              <FormattedMessage id="admin.runbooks.tasks.copy.tech" />
                            </TextStyle>
                          </div>
                          <div className="fx actr">
                            <Avatar
                              initials={
                                this.state.task?.technician?.name
                                  ? this.state.task?.technician?.name?.[0]
                                  : 'NA'
                              }
                              size="extraSmall"
                            />
                            <div className="f11 ml-10">
                              <div data-qa="taskTechnician">
                                <Select
                                  value={
                                    task?.technician?.name
                                      ? {
                                          name: task?.technician?.name || null,
                                          value: task?.technician?.name || null,
                                          label: task?.technician?.name || null
                                        }
                                      : null
                                  }
                                  isClearable
                                  styles={
                                    errors?.technician
                                      ? {
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999
                                          }),
                                          menu: (base) => ({
                                            ...base,
                                            zIndex: 9999
                                          }),
                                          ...reactSelectErrorStyles
                                        }
                                      : {
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999
                                          }),
                                          menu: (base) => ({
                                            ...base,
                                            zIndex: 9999
                                          })
                                        }
                                  }
                                  components={{
                                    IndicatorSeparator,
                                    DropdownIndicator
                                  }}
                                  name="team"
                                  onChange={this.updateSelectFields.bind(
                                    this,
                                    'technician'
                                  )}
                                  options={this.state.allTechnicians || []}
                                  isDisabled={disableEdit}
                                />
                                {errors?.technician &&
                                  reactSelectInlineError(errors.technician)}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {isTemplate ? (
                        <>
                          {!hideSections.includes('scheduledStartDate') && (
                            <div className="mb-20">
                              <div className="mb5">
                                <TextStyle variation="subdued">
                                  <FormattedMessage id="admin.projectTemplate.startDate" />
                                </TextStyle>
                              </div>

                              <div className="mt-10">
                                <div
                                  className="fx actr"
                                  onClick={this.selectCustomUnit}
                                >
                                  <CustomRadioButton
                                    checked={
                                      task?.scheduledStartDate?.unit ===
                                      'CUSTOM'
                                    }
                                  />
                                  <span className="ml-10 ptr">
                                    <FormattedMessage id="admin.taskTemplate.startDate.creation" />
                                  </span>
                                </div>
                                <div className="fx actr">
                                  <CustomRadioButton
                                    checked={
                                      task?.scheduledStartDate?.unit === 'DAY'
                                    }
                                    onClick={this.selectDaysUnit}
                                  />
                                  <div className="flex actr ml-10">
                                    <span
                                      className="ptr"
                                      onClick={this.selectDaysUnit}
                                    >
                                      <FormattedMessage id="admin.taskTemplate.startDate.custom" />
                                    </span>
                                    &nbsp;
                                    <NumberInput
                                      value={task?.scheduledStartDate?.value}
                                      suffix={getTranslatedText(
                                        intl,
                                        'admin.projectTemplate.startDate.custom.days'
                                      )}
                                      size="extrasmall"
                                      type="number"
                                      min={0}
                                      onChange={(val) =>
                                        this.handleTemplateDateHandler(
                                          { unit: 'DAY', value: val },
                                          'scheduledStartDate'
                                        )
                                      }
                                      onBlur={(event) => {
                                        if (
                                          parseInt(event.target.value, 10) < 0
                                        ) {
                                          this.handleTemplateDateHandler(
                                            { unit: 'DAY', value: '0' },
                                            'scheduledStartDate'
                                          );
                                        } else {
                                          const days = Math.round(
                                            parseInt(event.target.value, 10)
                                          );
                                          this.handleTemplateDateHandler(
                                            {
                                              unit: 'DAY',
                                              value: (Number.isNaN(days)
                                                ? ''
                                                : days
                                              )?.toString()
                                            },
                                            'scheduledStartDate'
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {!hideSections.includes('dueDate') && (
                            <div className="mb-20">
                              <div className="mb5">
                                <TextStyle variation="subdued">
                                  <FormattedMessage id="admin.projectTemplate.endDate" />
                                </TextStyle>
                              </div>

                              <div className="flex actr mt-10">
                                <FormattedMessage id="admin.projectTemplate.endDate.custom" />
                                &nbsp;
                                <NumberInput
                                  value={task?.dueDate?.value}
                                  suffix={getTranslatedText(
                                    intl,
                                    'admin.projectTemplate.endDate.custom.days'
                                  )}
                                  min={0}
                                  onChange={(val) =>
                                    this.handleTemplateDateHandler(
                                      { unit: 'DAY', value: val },
                                      'dueDate'
                                    )
                                  }
                                  onBlur={(event) => {
                                    if (parseInt(event.target.value, 10) < 0) {
                                      this.handleTemplateDateHandler(
                                        { unit: 'DAY', value: '0' },
                                        'dueDate'
                                      );
                                    } else {
                                      const days = Math.round(
                                        parseInt(event.target.value, 10)
                                      );
                                      this.handleTemplateDateHandler(
                                        {
                                          unit: 'DAY',
                                          value: (Number.isNaN(days)
                                            ? ''
                                            : days
                                          )?.toString()
                                        },
                                        'dueDate'
                                      );
                                    }
                                  }}
                                  size="extrasmall"
                                  type="number"
                                />
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          {!hideSections.includes('scheduledStartDate') && (
                            <div className="mb-20" data-qa="taskStartDate">
                              <div className="mb5">
                                <TextStyle variation="subdued">
                                  <FormattedMessage id="admin.runbooks.tasks.copy.startdate" />
                                </TextStyle>
                              </div>

                              <div className="fx actr">
                                <div
                                  className="fx center mr-10"
                                  style={{ opacity: 0.6 }}
                                >
                                  <SVGIcon name="DatePicker" />
                                </div>
                                <div className="f11">
                                  <DateTimePicker
                                    selected={
                                      task?.scheduledStartDate &&
                                      dayjs(task.scheduledStartDate).toDate()
                                    }
                                    onChange={(date) =>
                                      this.selectDateHandler(
                                        date,
                                        'scheduledStartDate'
                                      )
                                    }
                                    placeholderText={getTranslatedText(
                                      intl,
                                      'admin.runbooks.tasks.copy.startdate.pl'
                                    )}
                                    dateFormat="yyyy-MM-dd h:mm aa"
                                    showTimeInput
                                    disabled={disableEdit}
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          {!hideSections.includes('dueDate') && (
                            <div className="mb-20" data-qa="taskDueDate">
                              <div className="mb5">
                                <TextStyle variation="subdued">
                                  <FormattedMessage id="admin.runbooks.tasks.copy.duedate" />
                                </TextStyle>
                              </div>

                              <div className="fx actr">
                                <div
                                  className="fx center mr-10"
                                  style={{ opacity: 0.6 }}
                                >
                                  <SVGIcon name="DatePicker" />
                                </div>
                                <div className="f11">
                                  <DateTimePicker
                                    selected={
                                      task?.dueDate &&
                                      dayjs(task.dueDate).toDate()
                                    }
                                    onChange={(date) =>
                                      this.selectDateHandler(date, 'dueDate')
                                    }
                                    placeholderText={getTranslatedText(
                                      intl,
                                      'admin.runbooks.tasks.copy.duedate.pl'
                                    )}
                                    dateFormat="yyyy-MM-dd h:mm aa"
                                    showTimeInput
                                    popperPlacement="top-end"
                                    disabled={disableEdit}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      {!hideSections.includes('estimatedTime') && (
                        <div className="mb-20" data-qa="taskEstimatedTime">
                          <div className="mb5">
                            <TextStyle variation="subdued">
                              <FormattedMessage id="admin.runbooks.tasks.copy.estTime" />
                            </TextStyle>
                          </div>
                          <div className="fx actr">
                            <div className="mr-10">
                              <div
                                className="fx center mr-10"
                                style={{ opacity: 0.6 }}
                              >
                                <SVGIcon name="EstimatedTime" />
                              </div>
                            </div>
                            <div>
                              {/* Hours */}
                              <div className="fx actr mb-10">
                                <div
                                  className="mr10 w-130"
                                  data-qa="taskEstHours"
                                >
                                  <TextField
                                    type="number"
                                    value={hrValue}
                                    onChange={(val) =>
                                      this.handleTimeCalculation(val, 'hrValue')
                                    }
                                    inputMode="numeric"
                                    min={0}
                                    onBlur={(event) => {
                                      if (parseInt(event.target.value, 10) < 0)
                                        this.handleTimeCalculation(
                                          '0',
                                          'hrValue'
                                        );
                                    }}
                                    placeholder={getTranslatedText(
                                      intl,
                                      'admin.runbooks.tasks.copy.hours.pl'
                                    )}
                                    disabled={disableEdit}
                                  />
                                </div>
                                <div className=" mr-10">
                                  <TextStyle variation="subdued">
                                    <FormattedMessage id="admin.runbooks.tasks.copy.hour" />
                                  </TextStyle>
                                </div>
                              </div>

                              {/* Mins */}
                              <div className="fx actr">
                                <div
                                  className="mr-10 w-130"
                                  data-qa="taskEstMins"
                                >
                                  <TextField
                                    type="number"
                                    value={minValue}
                                    onChange={(val) =>
                                      this.handleTimeCalculation(
                                        val,
                                        'minValue'
                                      )
                                    }
                                    inputMode="numeric"
                                    min={0}
                                    onBlur={(event) => {
                                      if (parseInt(event.target.value, 10) < 0)
                                        this.handleTimeCalculation(
                                          '0',
                                          'minValue'
                                        );
                                    }}
                                    placeholder={getTranslatedText(
                                      intl,
                                      'admin.runbooks.tasks.copy.min.pl'
                                    )}
                                    disabled={disableEdit}
                                  />
                                </div>
                                <div className="mr-10">
                                  <TextStyle variation="subdued">
                                    <FormattedMessage id="admin.runbooks.tasks.copy.min" />
                                  </TextStyle>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {ticketViewPermission &&
                        showParent &&
                        (data?.ticket || data?.project) && (
                          <div className="mb-20">
                            <div className="mb5">
                              <TextStyle variation="subdued">
                                {data?.ticket ? (
                                  <FormattedMessage id="admin.task.parent.ticket" />
                                ) : (
                                  <FormattedMessage id="admin.task.parent.project" />
                                )}
                              </TextStyle>
                            </div>

                            <div className="fx actr">
                              <Link
                                removeUnderline
                                onClick={
                                  data?.ticket
                                    ? () =>
                                        this.context.openTab({
                                          ticketId: data?.ticket?.ticketId,
                                          module: 'TICKET',
                                          data: {
                                            subject: data?.ticket?.subject,
                                            displayId: data?.ticket?.displayId,
                                            ticketId: data?.ticket?.ticketId
                                          }
                                        })
                                    : () =>
                                        this.context.openTab({
                                          projectId: data?.project?.ticketId,
                                          module: ALL_MODULES.projectDetail,
                                          data: {
                                            projectId: data?.project?.projectId,
                                            title: data?.project?.title
                                          }
                                        })
                                }
                              >
                                {data?.ticket?.subject ||
                                  data?.project?.title ||
                                  'Click here'}
                              </Link>
                            </div>
                          </div>
                        )}
                    </DetailsContainer>
                  </>
                )}
              </div>
            </Page>
          </div>
        </ModalContent>
      </>
    );
  }
}

export default injectIntl(TaskForm);
